<template>
  <!-- style="overflow-y: auto;position: absolute;left: 0;right: 0;top: 0;bottom: 0;" -->
  <div>
    <!-- 头部 -->
    <div class="header">
      <header-tag :title="'账号信息'"></header-tag>
    </div>
    <!-- 表单部分 -->
    <div class="body">
      <div class="form-body">
        <div class="form-left">
          <p>通行证账号:</p>
          <p>手机号:</p>
          <p class="head">头像:</p>
        </div>
        <div class="form-right">
          <p v-text="form.passportName"></p>
          <p v-text="form.phone"></p>
          <p class="modify-phone" @click="showPhoneModals" v-show="form.passportType == 0">
            修改手机
          </p>
          <p class="head">
            <img src="@/assets/img/icon/head60.png" alt="" />
          </p>
        </div>
      </div>
      <div class="form-body" style="border-top: 2px dashed rgb(230, 230, 230);">
        <div class="form-left">
          <p>邮箱:</p>
          <p>怎么称呼你:</p>
          <p>QQ号:</p>
          <p>公司名称:</p>
          <p>通信地址</p>
        </div>
        <div class="form-right">
          <p>
            <input type="text" placeholder="请填写邮箱地址" v-model="form.passportMail" />
          </p>
          <p>
            <input type="text" placeholder="请填写你的称呼" v-model="form.personalName" />
          </p>
          <p>
            <input type="text" placeholder="请输入QQ号" v-model="form.personalQQ" />
          </p>
          <p>
            <input type="text" placeholder="请填写公司名称" v-model="form.companyName" />
          </p>
          <p class="threelinkage">
            <city-selector ref="threelinkage"></city-selector>
          </p>
          <p>
            <input type="text" placeholder="请填写详细地址" v-model="form.address" />
          </p>
          <p>
            <button @click="submitUserInfo">保存</button>
            <span v-text="msg"></span>
          </p>
        </div>
      </div>
    </div>
    <fade-down-modal :show="showPhone">
      <div style="width:600px;background:#fff;margin:0 auto;">
        <change-phone @showPhone="phone"></change-phone>
      </div>
    </fade-down-modal>
  </div>
</template>
<script>
import HeaderTag from "_c/tagTitle/headerTag"; //引入头部组件
import { getUserInfo } from "@/requests/user"; //获取用户信息
import { updateUserInfo } from "@/requests/user"; //用户信息修改
import FadeDownModal from "_c/modals/fadeDown";
import ChangePhone from "../accountSafe/modals/changePhone";
import CitySelector from "_c/selector/citySelector";
import { mapActions } from "vuex";
export default {
  name: "userInfo",
  components: {
    HeaderTag,
    FadeDownModal,
    ChangePhone,
    CitySelector
  },
  data () {
    return {
      msg: "", //提示信息
      showPhone: false, //修改绑定手机弹框
      form: {}
    };
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getUser();
    });
  },
  methods: {
    ...mapActions(["user/actionSetUserInfo"]),
    // 获取用户信息
    async getUser () {
      let res = await getUserInfo();
      this.form = res.data;
      this.cityNo = res.data.cityId;
      if (this.form.companyName == null)
      {
        this.form.companyName = "";
      }
      if (this.form.address == null)
      {
        this.form.address = "";
      }
      if (this.form.personalQQ == null)
      {
        this.form.personalQQ = "";
      }
      this.$refs.threelinkage.init({
        grepA: String(res.data.cityId).slice(0, 2),
        grepB: String(res.data.cityId).slice(0, 4),
        grepC: res.data.cityId
      });
    },
    // 信息修改提交
    async submitUserInfo () {
      if (this.form.passportMail == null)
      {
        this.msg = "邮箱不能为空";
        return false;
      }
      if (
        this.form.personalName.length < 2 ||
        this.form.personalName.length > 10
      )
      {
        this.msg = "称呼长度在2-10个之间";
        return false;
      }
      this.form.cityId = this.$refs.threelinkage.getRes();
      if (this.form.cityId == false)
      {
        this.msg = "请选择地址";
        return false;
      }
      let obj = this.form;
      let res = await updateUserInfo(obj);
      if (res.code == 200)
      {
        this.msg = res.msg;
        this["user/actionSetUserInfo"]();
      } else
      {
        this.msg = res.msg;
      }
    },
    showPhoneModals () {
      this.showPhone = true;
    },
    phone (data) {
      this.showPhone = data;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "_style/msgbox/_comMsg.scss";

.header {
  padding-left: 30px;
  text-align: left;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d9dee4;
}

.form-body {
  overflow: hidden;
  margin-left: 50px;
  width: 90%;
  padding: 10px 0px 20px 0px;

  .form-left {
    float: left;
    width: 150px;
    text-align: right;
    font-size: 14px;
    color: rgb(161, 161, 161);
    line-height: 40px;
  }

  .form-right {
    float: left;
    padding-left: 15px;
    width: 300px;
    text-align: left;
    line-height: 40px;

    input {
      width: 285px;
      height: 30px;
      padding-left: 10px;
      border: 1px solid #d9dee4;
    }

    span {
      position: absolute;
      transform: translate(-100px, 0px);
      color: #f00;
    }

    button {
      margin-top: 50px;
      width: 100px;
      line-height: 30px;
      color: #fff;
      background-color: rgb(0, 153, 204);
    }

    select {
      width: 97px;
    }
  }
}

.head {
  line-height: 60px;

  img {
    border-radius: 50px;
  }
}

.modify-phone {
  position: absolute;
  transform: translate(200px, -40px);
  color: rgb(0, 102, 204);
  cursor: pointer;
}
</style>
